module.exports = __webpack_public_path__ + "img/4.d80b7220.jpg";